<!-- eslint-disable -->
<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="100%"
    height="100%"
    x="0px"
    y="0px"
    viewBox="0 0 48.3 53.5"
    style="enable-background:new 0 0 48.3 53.5;"
    xml:space="preserve"
  >
    <path
      class="animate-helper st0"
      d="M15.8,53.4c-2.2-1.5-4.1-3.7-5.6-5.9c-3.4-5.1-5.1-11.3-5.5-17.4c-0.1-1.1-0.1-2.3-0.1-3.5c0-1.2,0-2.3,0.1-3.5
	 		C5.1,17,6.8,10.9,10.2,5.7c1.4-2.1,3.2-4.1,5.3-5.7c-2.2,0.2-4.4,1-6.1,2.3C7,4.1,5.2,6.7,3.8,9.3c-1.7,3.3-2.7,6.9-3.3,10.5
	 		c-0.3,2.3-0.5,4.7-0.5,7s0.2,4.6,0.5,6.9c0.6,3.6,1.6,7.2,3.3,10.5c1.4,2.7,3.2,5.2,5.6,7C11.2,52.6,13.4,53.4,15.8,53.4
	 		C15.8,53.5,15.8,53.5,15.8,53.4L15.8,53.4z"
    />
    <g class="animate-helper">
      <path
        class="st0"
        d="M19.8,1c0.1,0,0.1,0,0.2,0.1c-0.6,0.3-1.2,0.6-1.8,1c0,0-0.1-0.1-0.1-0.1c-0.1,0.1-0.2,0.2-0.4,0.3
			c-2.4,1.8-4.2,4.4-5.6,7c-1.7,3.3-2.7,6.9-3.3,10.5c-0.2,1.1-0.3,2.3-0.4,3.5v6.2c0.1,1.4,0.2,2.7,0.4,4.1
			c0.6,3.6,1.6,7.2,3.3,10.5c1.3,2.5,2.9,4.8,5.1,6.6c0.7-0.7,1.3-1.5,1.9-2.3c-0.2-0.3-0.4-0.6-0.6-0.9c-3.4-5.1-5.1-11.3-5.5-17.4
			c-0.1-1.1-0.1-2.3-0.1-3.5c0-1.2,0-2.3,0.1-3.5c0.4-6.1,2.1-12.2,5.5-17.4c0.5-0.4,1-1,1.5-1.6c0.6-0.7,1.2-1.4,1.8-2
			c0.7-0.7,1.4-1.3,2.2-1.8c0-0.1,0.1-0.2,0.1-0.3C22.7,0,21.2,0.4,19.8,1C19.9,1,19.9,1,19.8,1z"
      />
      <path
        class="st0"
        d="M23.3,53.4c0.2,0,0.5-0.1,0.7-0.1c-0.2-0.1-0.4-0.2-0.6-0.4c-0.6-0.4-1.1-0.9-1.6-1.4c0,0-0.1,0.1-0.1,0.1
			c-0.5,0.4-1.1,0.6-1.6,0.9c0.9,0.4,1.8,0.7,2.6,0.9c0.2,0,0.4,0,0.7,0.1c0.1,0,0.2,0,0.2,0C23.5,53.5,23.4,53.4,23.3,53.4z"
      />
    </g>
    <g class="animate-helper">
      <path
        class="st0"
        d="M21.8,51.5C21.8,51.5,21.8,51.5,21.8,51.5c0.1-0.1,0.2-0.1,0.3-0.2c0.7-0.5,1.4-1.2,2-1.8c0,0,0,0,0-0.1
			c0,0,0,0,0,0c0.8-0.9,1.5-1.8,2.2-2.8c0,0,0,0,0,0.1c0.5-0.8,1-1.6,1.4-2.4c1.7-3.3,2.7-6.9,3.3-10.5c0.4-2.3,0.5-4.6,0.5-6.9
			c0-2.3-0.2-4.6-0.5-6.9c-0.6-3.6-1.6-7.2-3.3-10.5c-0.2-0.4-0.4-0.8-0.6-1.1c-0.8,1.4-1.6,3.2-2.2,4.9c1.1,3.2,1.7,6.6,1.9,10
			c0.1,1.1,0.1,2.3,0.1,3.5s0,2.3-0.1,3.5c-0.3,4.1-1.2,8.3-2.7,12.1c-0.6,1.5-1.3,2.9-2.2,4.3c-0.2,0.3-0.4,0.7-0.6,1
			c-0.4,0.6-0.9,1.3-1.4,1.9c-0.6,0.7-1.2,1.4-1.8,2c-0.7,0.7-1.4,1.3-2.2,1.8c0,0-0.1,0-0.1,0v0h1.1c1-0.2,2.1-0.5,3-0.9
			c0.1,0,0.1-0.1,0.2-0.1c0,0,0,0-0.1,0C20.6,52.2,21.2,51.9,21.8,51.5z"
      />
      <path
        class="st0"
        d="M24.1,4.1c-0.5-0.5-1-0.9-1.4-1.4C22,3.4,21.4,4.2,20.8,5c0.2,0.3,0.4,0.6,0.6,0.9c0.2,0.3,0.4,0.6,0.6,1
			C22.6,5.9,23.3,5,24.1,4.1C24.1,4.1,24.1,4.1,24.1,4.1z"
      />
      <path
        class="st0"
        d="M19.8,1c-1.3-0.6-2.6-0.9-4-0.9v0.1c0.8,0.5,1.5,1.1,2.3,1.8c0,0,0,0,0,0C18.7,1.6,19.3,1.3,19.8,1z"
      />
    </g>
    <g class="animate-helper">
      <path
        class="st0"
        d="M26.1,2.3c-0.7,0.5-1.4,1.2-2,1.8c0,0,0,0,0.1,0C23.4,5,22.7,5.9,22,6.9c-0.5,0.8-1,1.6-1.4,2.4
			c-1.7,3.3-2.7,6.9-3.3,10.5c-0.4,2.3-0.5,4.7-0.5,6.9c0,2.3,0.2,4.6,0.5,6.9c0.6,3.6,1.6,7.2,3.3,10.5c0.2,0.4,0.4,0.8,0.6,1.1
			c0.9-1.6,1.6-3.3,2.2-5.1c-1.1-3.2-1.7-6.6-1.9-10c-0.1-1.1-0.1-2.3-0.1-3.5c0-1.2,0-2.3,0.1-3.5c0.3-4.1,1.2-8.3,2.7-12.1
			c0.6-1.5,1.3-2.9,2.2-4.3c0.2-0.3,0.4-0.7,0.6-1c0.4-0.6,0.9-1.3,1.4-1.9c0.6-0.7,1.2-1.4,1.8-2c0.7-0.7,1.4-1.3,2.2-1.8
			c-1.4,0-2.8,0.4-4.1,1c-0.6,0.3-1.2,0.7-1.8,1C26.4,2.1,26.3,2.2,26.1,2.3z"
      />
      <path
        class="st0"
        d="M24.1,49.4c0.5,0.5,1,0.9,1.5,1.4c0.7-0.7,1.3-1.5,1.9-2.3c-0.2-0.3-0.4-0.6-0.6-0.9c-0.2-0.3-0.4-0.6-0.6-0.9
			c0,0,0,0,0,0C25.6,47.7,24.9,48.6,24.1,49.4z"
      />
      <path
        class="st0"
        d="M28.5,52.6c1.2,0.5,2.6,0.9,4,0.9v-0.1c-0.8-0.5-1.5-1.1-2.3-1.8c0,0-0.1,0.1-0.1,0.1
			C29.6,52.1,29,52.3,28.5,52.6z"
      />
    </g>
    <g class="animate-helper">
      <path
        class="st0"
        d="M28.3,52.7c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.1-0.1-0.2-0.1c0.6-0.3,1.2-0.6,1.8-1c0,0,0.1,0.1,0.1,0.1
			c0.1-0.1,0.2-0.1,0.3-0.2c2.4-1.8,4.2-4.4,5.6-7c1.7-3.3,2.7-6.9,3.3-10.5c0.4-2.3,0.5-4.6,0.5-6.9s-0.2-4.6-0.5-6.9
			c-0.6-3.6-1.6-7.2-3.3-10.5C34.8,7.1,33.2,4.8,31,3c-0.7,0.5-1.3,1.3-1.9,2.1c0.2,0.3,0.4,0.6,0.6,0.9c3.4,5.1,5.1,11.3,5.5,17.4
			c0.1,1.1,0.1,2.3,0.1,3.5c0,1.2,0,2.3-0.1,3.5c-0.4,6.1-2.1,12.2-5.5,17.4c-0.4,0.6-0.9,1.3-1.4,1.9c-0.6,0.7-1.2,1.4-1.8,2
			c-0.7,0.7-1.4,1.3-2.2,1.8h1.5C26.7,53.3,27.5,53.1,28.3,52.7z"
      />
      <path
        class="st0"
        d="M24.9,0.6C25.4,1,26,1.5,26.5,2c0.6-0.4,1.2-0.7,1.8-1c-0.9-0.4-1.8-0.7-2.7-0.9c-0.2,0-0.5-0.1-0.7-0.1
			c-0.3,0-0.5,0-0.8-0.1V0l0.1,0.1C24.4,0.3,24.7,0.4,24.9,0.6z"
      />
    </g>
    <path
      class="animate-helper st0"
      d="M44.5,9.7c-1.4-2.7-3.2-5.2-5.6-7c-1.9-1.8-4.1-2.6-6.4-2.6c2.2,1.5,4.1,3.7,5.6,5.9c3.4,5.1,5.1,11.3,5.5,17.4
		c0.1,1.1,0.1,2.3,0.1,3.5c0,1.2,0,2.3-0.1,3.5c-0.4,6.1-2.1,12.2-5.5,17.4c-1.4,2.1-3.3,4.1-5.4,5.7h1.9c1.5-0.4,3-1,4.3-2
		c2.4-1.8,4.2-4.4,5.6-7c1.7-3.3,2.7-6.9,3.3-10.5c0.4-2.3,0.5-4.6,0.5-6.9c0-2.3-0.2-4.6-0.5-6.9C47.3,16.6,46.2,13,44.5,9.7z"
    />
  </svg>
</template>

<style scoped lang="scss">
.st0 {
  fill: #e30613;
}
</style>
